// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"945":"692f5b22","999":"5599735f"}[chunkId] + ".chunk.css";
};